import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Option } from "@circle-react-shared/uikit/Combobox/Option";

interface CreatableOptionProps {
  isCreatingTopic: boolean;
  onCreateTopic: (topicName: string) => void;
  searchQuery: string;
}

export const CreatableOption = ({
  searchQuery,
  isCreatingTopic,
  onCreateTopic,
}: CreatableOptionProps) => (
  <Option
    option="create"
    key="create"
    onClick={e => {
      e.preventDefault();
      e.stopPropagation();
      if (isCreatingTopic) return;
      onCreateTopic(searchQuery);
    }}
    className="flex items-center"
  >
    <Icon
      className="mr-1"
      size={16}
      type={isCreatingTopic ? "loader" : "plus-v2"}
    />
    {t(
      isCreatingTopic
        ? "quick_post_v2.topics.creating"
        : "quick_post_v2.topics.create",
    )}
    <span className="text-dark ml-1 font-semibold">
      {t("quick_post_v2.topics.topic_quoted", {
        topic: searchQuery,
      })}
    </span>
  </Option>
);
